import rangeSlider from "../../common/range-slider";
import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";

export default {
  name: "partners-merchant",
  components: {
    rangeSlider,
    dateField,
    decimalField
  },
  data() {
    return {
      isSearchZipCode: false,
      labelName: "Cliente",
      labelIdentity: "CPF/CNPJ",
      countFilter: 0,
      filter: {
        Name: null,
        Identity: null,
        IdUserPartner: null,
        CodeMerchantType: null,
        IsExpiredCommission: null
      },
      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedContactTechStep: false,
      validatedTaxStep: false,
      validatedMerchant: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      loadingValidateMerchant: false,
      users: [],
      states: [],
      cities: [],
      bRange: {
        labels: ["R$ 1,96", "R$ 1,83", "R$ 1,55"],
        min: 1,
        max: 3,
        value: 1
      },
      pOpened: null,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      BankSlipTax: 0,
      CreditCardTax: 0,
      PixTax: 0,
      AnticipationTax: 0,
      infoPartnerMerchant: {
        Name: null,
        CommercialName: null,
        Identity: null,
        ResponsibleName: null,
        ResponsibleIdentity: null,
        ResponsiblePhone: null,
        Email: null,
        TechName: null,
        TechIdentity: null,
        TechEmail: null,
        WebsiteUrl: null,
        IsMEI: false,
        Taxes: {
          BankSlip: 1
        },
        MerchantType: {
          Code: "2"
        },
        Address: {
          Street: null,
          Number: null,
          District: null,
          ZipCode: null,
          Complement: null,
          CityName: null,
          StateInitials: null,
          CountryName: null,
          City: {
            Name: null,
            Id: null,
            CodeIBGE: null
          },
          State: {
            Name: null,
            Initials: null
          },
          Country: {
            Name: null,
            Id: null
          }
        },
        UserPartner: {
          Id: 0
        }
      },
      infoValidateMerchant: {
        Email: null,
        ResponsibleIdentity: null,
        Identity: null
      },
      isValidated: false,
      isSeeing: false,
      modalTitle: "Novo cliente",
      mSteps: ["company", "owner", "contact", "taxes", "checkList", "confirm"],
      mCurrentStep: 0,
      PartnerMerchants: [],
      PartnerMerchantCheckListDates: [],
      PartnerMerchantCheckLists: [],
      Countries: [],
      isCreating: false,
      PartnerTypeCode: 0
    };
  },
  computed: {
    IsAdministrator() {
      return this.$profileCode() === "1";
    },
    IsCommercial() {
      return this.$partnerTypeCode() === "1";
    },
    Country() {
      return this.infoPartnerMerchant.Address.Country.Id;
    },
    State() {
      return this.infoPartnerMerchant.Address.State.Initials;
    },
    AccountType() {
      return this.FormattedMerchantType(this.infoPartnerMerchant);
    },
    HasMerchantCheckList() {
      return this.isSeeing && this.merchantCheckLists != null && this.merchantCheckLists.length > 0;
    },
    FormattedAddress() {
      let formatted = `${this.infoPartnerMerchant.Address.Street}, ${this.infoPartnerMerchant.Address.Number} - ${this.infoPartnerMerchant.Address.District}, ${this.infoPartnerMerchant.Address.City.Name} - ${this.infoPartnerMerchant.Address.State.Initials} - ${this.infoPartnerMerchant.Address.Country.Name}`;
      return formatted;
    },
    FormattedTaxes() {
      return `Boleto: ${this.BankSlipCommission} - Cartão Crédito: ${this.CreditCardCommission} - Pix: ${this.PixCommission}`;
    },
    CommissionCompetences() {
      return this.$store.getters.CommissionCompetence;
    },
    TaxInfo() {
      return this.$store.getters.TaxInfo;
    }
  },
  watch: {
    "pagination.PageNumber"() {
      this.ListPartnerMerchant();
    },
    "pagination.RowsPerPage"() {
      this.ListPartnerMerchant();
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store.dispatch("GetCities", { stateInitials: selected }).then(response => {
          this.cities = response;
        });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoPartnerMerchant.Address.City.CodeIBGE = null;
        }
      } else {
        this.cities = [];
        this.infoPartnerMerchant.Address.City.CodeIBGE = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.GetStates(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoPartnerMerchant.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.infoPartnerMerchant.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    }
  },
  beforeMount() {
    this.PartnerTypeCode = this.$partnerTypeCode();
    this.GetAnticipationConfigurationTaxes();
  },
  mounted() {
    if (this.IsAdministrator) {
      this.ListSalesMan();
    }
    this.ListPartnerMerchant();
    this.ListCountries();
    this.$requestGetCommissionCompetence();
  },
  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListPartnerMerchant();
    },
    ResetFilter() {
      this.filter = {
        Name: null,
        Identity: null,
        IdUserPartner: null,
        CodeMerchantType: null,
        IsExpiredCommission: null
      };
      this.ListPartnerMerchant();
    },
    GetIsExpiredCommission(isEpiredCommission) {
      if (isEpiredCommission == undefined || isEpiredCommission == null || isEpiredCommission == 0) return "Ativo";
      return "Inativo";
    },
    GetDivClass(isEpiredCommission) {
      let variation = "td-with-subs-color badge badge-danger";
      if (isEpiredCommission == undefined || isEpiredCommission == null || isEpiredCommission == 0)
        variation = "td-with-subs-color badge badge-success";
      return variation;
    },
    ListSalesMan() {
      let data = {
        "Object.UserProfilePartner.Code": 2,
        PageNumber: 0,
        RowsPerPage: 0
      };
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.users = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de usuários", error);
        });
    },
    GetReport(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportPartnerMerchant", { params: data })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $("#meu-querido-dropdown > .dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    Placeholder(key, valueToValidate, caseTrue, caseFalse) {
      if (key == valueToValidate) return caseTrue;
      else return caseFalse;
    },
    resetModal() {
      this.validatedCompanyStep = false;
      this.validatedResponsibleStep = false;
      this.validatedContactTechStep = false;
      this.validatedTaxStep = false;
    },
    CheckValidityStepCompany(nextStep) {
      this.$refs.CompanyStep.validate().then(valid => {
        if (valid) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
    CheckValidityStepResponsible(nextStep) {
      var name = true;
      var cpf = true;
      if (this.infoPartnerMerchant.MerchantType.Code != "1") {
        // Se não é pessoa fisica os campos são obrigatórios.
        this.$refs.ResponsibleNameStep.validate().then(field => {
          name = field.valid;
        });
        this.$refs.ResponsibleCpfStep.validate().then(field => {
          cpf = field.valid;
        });
      }
      this.$refs.ResponsibleStep.validate().then(valid => {
        if (valid && name && cpf) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
    CheckValidityStepContactTechStep(nextStep) {
      this.$refs.TechStep.validate().then(valid => {
        const isPristine = this.$refs.TechStep.ctx.pristine;

        if (!valid && !isPristine) {
          this.validatedContactTechStep = true;
        } else {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
          this.validatedContactTechStep = false;
        }
      });
    },
    GoNextStep() {
      if (this.mCurrentStep == 3 && !this.isSeeing) {
        this.mCurrentStep += 2;
      }
      if (this.mCurrentStep < this.mSteps.length - 1) {
        this.mCurrentStep += 1;

        if (this.infoPartnerMerchant.MerchantType.Code == "1" && this.mCurrentStep == 2) {
          this.mCurrentStep += 1;
        }
      }
    },
    FormattedMerchantType(client) {
      if (client == null) return "Não categorizado";
      switch (client.MerchantType.Code) {
        case "1":
          return "Pessoa Física";
        case "2":
          return "Pessoa Jurídica";
        case "3":
          return "Marketplace";
        default:
          return "Não categorizado";
      }
    },
    GetAnticipationConfigurationTaxes() {
      this.$store.dispatch("ListConfigurationTax", {})
      .then(response => {
        const anticipationTaxList = [];

        const configurationTaxesList = response.Objects;
        configurationTaxesList.map(configurationTax => {
          if (configurationTax.PaymentMethod.Code == 15) {
            anticipationTaxList.push(configurationTax);
          }
        })

        this.anticipationTaxList = anticipationTaxList;
      })
    },
    GetCommissionCompetences(){
      let CommissionCompetences = [];
      if (hasValue(this.CommissionCompetences.BankSlip) && hasValue(this.CommissionCompetences.BankSlip.Taxes))
      {
        this.CommissionCompetences.BankSlip.Taxes[0].Tax = this.BankSlipTax;
        CommissionCompetences.push(this.CommissionCompetences.BankSlip.Taxes[0]);
      }
      if (hasValue(this.CommissionCompetences.CreditCard) && hasValue(this.CommissionCompetences.CreditCard.Taxes))
      {
        this.CommissionCompetences.CreditCard.Taxes[0].Tax = this.CreditCardTax;
        CommissionCompetences.push(this.CommissionCompetences.CreditCard.Taxes[0]);
      }
      if (hasValue(this.CommissionCompetences.Pix) && hasValue(this.CommissionCompetences.Pix.Taxes))
      {
        this.CommissionCompetences.Pix.Taxes[0].Tax = this.PixTax;
        CommissionCompetences.push(this.CommissionCompetences.Pix.Taxes[0]);
      }
      if (hasValue(this.CommissionCompetences.Anticipation) && hasValue(this.CommissionCompetences.Anticipation.Taxes))
      {
        this.CommissionCompetences.Anticipation.Taxes[0].Tax = this.AnticipationTax;
        CommissionCompetences.push(this.CommissionCompetences.Anticipation.Taxes[0]);
      }
      return CommissionCompetences;
    },
    AddPartnerMerchant() {
      this.loadingModal = true;
      this.infoPartnerMerchant.CommissionCompetences = this.GetCommissionCompetences();
      if (!this.isCreating) {
        this.$store
          .dispatch("UpdatePartnerMerchant", this.infoPartnerMerchant)
          .then(() => {
            this.$bvModal.hide("mFormMerchant");
            this.ListPartnerMerchant();
            this.$makeToast("O cliente foi atualizado com sucesso!", "success", "Atualização de Clientes");
          })
          .catch(error => {
            this.$makeToast("Não foi possível atualizar o Cliente.", "danger", "Atualização de Clientes", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetAddressByCep() {
      let zipCodeNumber = this.infoPartnerMerchant.Address.ZipCode.replace(/\D+/gm, "");

      if (zipCodeNumber.length != 8) {
        this.$makeToast("O CEP digitado não é válido. " + zipCodeNumber, "danger", "CEP inválido");
        return;
      }

      this.$store
        .dispatch("GetAddressByCep", {
          zipCode: zipCodeNumber
        })
        .then(response => {
          if (response.erro) {
            this.$makeToast("Verifique o número digitado e tente novamente.", "warning", "CEP não encontrado");
            return;
          }
          this.isSearchZipCode = true;

          this.infoPartnerMerchant.Address.Country.Id = 24;
          this.infoPartnerMerchant.Address.State.Initials = response.uf;

          this.infoPartnerMerchant.Address.Street = response.logradouro;
          this.infoPartnerMerchant.Address.District = response.bairro;

          this.infoPartnerMerchant.Address.City.CodeIBGE = response.ibge;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar o endereço.", "danger", "Busca de endereço", error);
        });
    },
    ListCountries() {
      this.$store.dispatch("GetCountries").then(response => {
        this.Countries = response;
      });
    },
    GetStates(countryId) {
      let self = this;

      this.$store
        .dispatch("GetStates", {
          idCountry: countryId
        })
        .then(response => {
          self.states = response;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar os estados.", "danger", "Listagem de estados", error);
        });
    },
    GetCities() {
      let self = this;

      this.$store
        .dispatch("GetCities", {
          stateInitials: self.infoPartnerMerchant.Address.State.Initials
        })
        .then(response => {
          self.cities = response;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar as cidades.", "danger", "Listagem de cidades", error);
        });
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Name": this.filter.Name,
        "Object.Identity": this.filter.Identity,
        "Object.UserPartner.Id": this.filter.IdUserPartner,
        "Object.MerchantType.Code": this.filter.CodeMerchantType,
        "Object.IsExpiredCommission": this.filter.IsExpiredCommission
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ListPartnerMerchant() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantType)) this.countFilter++;
      if (hasValue(this.filter.IsExpiredCommission)) this.countFilter++;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListPartnerMerchant", { params: data })
        .then(
          response => {
            this.PartnerMerchants = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          error => {
            this.$makeToast("Não foi possível listar os clientes.", "danger", "Listagem de clientes", error);
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetPartnerMerchant(id, seeing, isOnlyGet = false) {
      this.loadingModal = true;
      let self = this;
      this.mCurrentStep = 0;
      this.isCreating = false;

      this.ResetInfoPartnerMerchant();
      if (isOnlyGet == false) {
        self.OpenMPartnerMerchant();
        this.ListPartnerMerchantChecklist(id);
      }
      this.$store
        .dispatch("GetPartnerMerchant", { id: id })
        .then(response => {
          self.infoPartnerMerchant = response.Merchant;
          self.FormatTaxInfo(response.TaxInfo);
          self.FormatCompetences(response.CommissionCompetenceListAux);

          if (self.infoPartnerMerchant.MerchantType.Code == "1") {
            self.mSteps = ["company", "owner", "taxes", "checklist", "confirm"];
          } else {
            self.mSteps = ["company", "owner", "contact", "taxes", "checklist", "confirm"];
          }
          if (seeing === true) {
            self.isSeeing = true;
            self.modalTitle = "Detalhes do cliente";
          } else {
            self.isSeeing = false;
            self.modalTitle = "Editar cliente";
          }
        })
        .catch(error => {
          self.$makeToast("Não foi possível buscar o cliente.", "danger", "Visualização de clientes", error);
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    NextStep(nextStep) {
      if (this.isSeeing) {
        if (nextStep != null) {
          this.mCurrentStep = nextStep;
        } else {
          this.GoNextStep();
        }
        return;
      }
      switch (this.mCurrentStep) {
        case 0: // Empresa
          this.validatedCompanyStep = true;
          this.CheckValidityStepCompany(nextStep);
          break;
        case 1: // Responsavel
          this.validatedResponsibleStep = true;
          this.CheckValidityStepResponsible(nextStep);
          break;
        case 2: // Contato tecnico
          this.validatedContactTechStep = true;
          this.CheckValidityStepContactTechStep(nextStep);
          break;
        case 3: // Taxas
          this.validatedTaxStep = true;
          this.CheckValidityStepTax(nextStep);
          break;
        default:
          if (nextStep != null) {
            this.mCurrentStep = nextStep;
          } else {
            this.GoNextStep();
          }
          break;
      }
    },
    BackStep() {
      if (this.mCurrentStep == 5 && !this.isSeeing) {
        this.mCurrentStep -= 1;
      }
      if (this.mCurrentStep >= 1) {
        this.mCurrentStep -= 1;

        if (this.infoPartnerMerchant.MerchantType.Code == "1" && this.mCurrentStep == 2) {
          this.mCurrentStep -= 1;
        }
      }
    },
    OpenMNewPartnerMerchant() {
      this.ResetInfoPartnerMerchant();
      this.isSeeing = false;
      this.isCreating = true;
      this.modalTitle = "Novo cliente";
      this.mCurrentStep = 0;
      this.mSteps = ["company", "owner", "contact", "taxes", "checkList", "confirm"];

      this.OpenMPartnerMerchant();
    },
    OpenMPartnerMerchant() {
      this.resetModal();
      this.$bvModal.show("mFormMerchant");
    },
    ResetInfoPartnerMerchant() {
      this.infoPartnerMerchant = {
        Name: null,
        CommercialName: null,
        Identity: null,
        ResponsibleName: null,
        ResponsibleIdentity: null,
        Email: null,
        TechName: null,
        TechIdentity: null,
        TechEmail: null,
        MerchantType: {
          Code: "2"
        },
        Address: {
          Street: null,
          Number: null,
          District: null,
          ZipCode: null,
          Complement: null,
          CityName: null,
          StateInitials: null,
          CountryName: null,
          City: {
            Name: null,
            CodeIBGE: null
          },
          State: {
            Name: null,
            Initials: null
          },
          Country: {
            Name: null,
            Id: null
          }
        },
        UserPartner: {
          Id: 0
        }
      };
    },
    GoToStep(e, s) { /// Ajustar prev/next steps baseando-se no merchantpreview
      e.preventDefault();
      if (s < this.mSteps.length && s >= 0) {
        if (s < this.mCurrentStep) {
          this.mCurrentStep = s;
        } else {
          this.NextStep(s);
        }
      }
    },
    floatToReal(v, t) {
      if (t === 2) {
        return "R$ " + v.toFixed(2).replace(".", ",");
      } else {
        return v.toFixed(2) + "%";
      }
    },
    ListPartnerMerchantChecklist(id) {
      this.$store
        .dispatch("ListPartnerMerchantChecklist", { id: id })
        .then(response => {
          this.merchantCheckLists = response.Checklists;
          this.merchantCheckListDates = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os checklists", error);
        });
    },
    FormatTaxInfo(res) {
      let TaxInfo = {
        BankSlip: { Show: false },
        CreditCard: { Show: false },
        Pix: { Show: false },
        Anticipation: { Show: false },
      };

      for (const i in res) {
        switch (i) {
          case "1":
            TaxInfo.BankSlip.Show = true;
            TaxInfo.BankSlip.Name = res[i].PaymentMethodName;
            TaxInfo.BankSlip.Min = res[i].Min;
            TaxInfo.BankSlip.Max = res[i].Max;
            TaxInfo.BankSlip.Commission = res[i].Commission;
            TaxInfo.BankSlip.Tax = res[i].Tax;
            break;
          case "2":
            TaxInfo.CreditCard.Show = true;
            TaxInfo.CreditCard.Name = res[i].PaymentMethodName;
            TaxInfo.CreditCard.Min = res[i].Min;
            TaxInfo.CreditCard.Max = res[i].Max;
            TaxInfo.CreditCard.Commission = res[i].Commission;
            TaxInfo.CreditCard.Tax = res[i].Tax;
            break;
          case "6":
            TaxInfo.Pix.Show = true;
            TaxInfo.Pix.Name = res[i].PaymentMethodName;
            TaxInfo.Pix.Min = res[i].Min;
            TaxInfo.Pix.Max = res[i].Max;
            TaxInfo.Pix.Commission = res[i].Commission;
            TaxInfo.Pix.Tax = res[i].Tax;
            break;
          case "17":
            TaxInfo.Anticipation.Show = true;
            TaxInfo.Anticipation.Name = res[i].PaymentMethodName;
            TaxInfo.Anticipation.Min = res[i].Min;
            TaxInfo.Anticipation.Max = res[i].Max;
            TaxInfo.Anticipation.Commission = res[i].Commission;
            TaxInfo.Anticipation.Tax = res[i].Tax;
            break;
        }
      }
      this.$store.commit("SET_TAX_INFO", TaxInfo);
      this.BankSlipTax = TaxInfo.BankSlip.Tax;
      this.CreditCardTax = TaxInfo.CreditCard.Tax;
      this.PixTax = TaxInfo.Pix.Tax;
      this.AnticipationTax = TaxInfo.Anticipation.Tax;
    },
    FormatCompetences(res) {
      let commissionCompetences = new Object();
      commissionCompetences.BankSlip = {};
      commissionCompetences.CreditCard = {};
      commissionCompetences.Crypto = {};
      commissionCompetences.Pix = {};
      commissionCompetences.Anticipation = {};

      for (let x = 0; x < res.length; x++) {
        switch (res[x].PaymentMethod.Code) {
          case "1":
            commissionCompetences.BankSlip.Show = true;
            commissionCompetences.BankSlip.Name = res[x].PaymentMethod.Name;
            commissionCompetences.BankSlip.Taxes = res[x].CommissionCompetence;

            commissionCompetences.BankSlip.Labels = [];
            for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
              const value = res[x].CommissionCompetence[y].Tax;
              const type = res[x].CommissionCompetence[y].TaxType.Id;
              commissionCompetences.BankSlip.Labels.push(this.floatToReal(value, type));
            }
            break;
          case "2":
            commissionCompetences.CreditCard.Show = true;
            commissionCompetences.CreditCard.Name = res[x].PaymentMethod.Name;
            commissionCompetences.CreditCard.Taxes = res[x].CommissionCompetence;

            commissionCompetences.CreditCard.Labels = [];
            for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
              const value = res[x].CommissionCompetence[y].Tax;
              const type = res[x].CommissionCompetence[y].TaxType.Id;
              commissionCompetences.CreditCard.Labels.push(this.floatToReal(value, type));
            }
            break;
          case "6":
            commissionCompetences.Pix.Show = true;
            commissionCompetences.Pix.Name = res[x].PaymentMethod.Name;
            commissionCompetences.Pix.Taxes = res[x].CommissionCompetence;

            commissionCompetences.Pix.Labels = [];
            for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
              const value = res[x].CommissionCompetence[y].Tax;
              const type = res[x].CommissionCompetence[y].TaxType.Id;
              commissionCompetences.Pix.Labels.push(this.floatToReal(value, type));
            }
            break;
          case "15":
            commissionCompetences.Anticipation.Show = true;
            commissionCompetences.Anticipation.Name = res[x].PaymentMethod.Name;
            commissionCompetences.Anticipation.Taxes = res[x].CommissionCompetence;

            commissionCompetences.Anticipation.Labels = [];
            for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
              const value = res[x].CommissionCompetence[y].Tax;
              const type = res[x].CommissionCompetence[y].TaxType.Id;
              commissionCompetences.Anticipation.Labels.push(this.floatToReal(value, type));
            }
            break;
        }
      }

      this.$store.commit("SET_COMMISSION_COMPETENCE_LIST", commissionCompetences);
    },
    OpenMUserPartner(id) {
      this.GetPartnerMerchant(id, true, true);
      this.$bvModal.show("mUserPartner");
    },
    ConfirmUpdateUserPartner() {
      this.$makeMsgBox(
        "Você tem certeza que deseja vincular o vendedor(a) a este cliente?",
        "Confirmar",
        this.UpdateUserPartner
      );
    },
    UpdateUserPartner() {
      this.infoPartnerMerchant.UserPartner.Id = this.infoPartnerMerchant.UserPartner.Id;
      this.$store
        .dispatch("UpdateUserPartner", this.infoPartnerMerchant)
        .then(() => {
          this.$makeToast("O vendedor foi vinculado com sucesso!", "success", "Vinculação de vendedor");
          this.$bvModal.hide("mUserPartner");
          this.ListPartnerMerchant();
        })
        .catch(error => {
          this.$makeToast("Não foi possível vincular o Vendedor.", "danger", "Vinculação de vendedor", error);
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    OpenValidateMerchant() {
      this.loadingValidateMerchant = false;
      this.validatedMerchant = false;
      this.infoValidateMerchant = {
        Email: null,
        ResponsibleIdentity: null,
        Identity: null
      };
      this.$bvModal.show("mValidateMerchant");
    },
    htmlToVNode(html) {
      return [
        this.$createElement("div", {
          domProps: { innerHTML: this.$options.filters.breakline(html) }
        })
      ];
    },
    ConfirmHasErrorValidate(response) {
      this.$makeMsgBox(
        this.htmlToVNode(response.MessageValidate + "Você tem certeza que deseja continuar?"),
        "Confirmar",
        this.SetMerchant,
        response
      );
    },
    SetMerchant(response) {
      this.OpenMNewPartnerMerchant();
      this.infoPartnerMerchant.Name = response.Name;
      this.infoPartnerMerchant.IsMEI = response.IsMEI;
      this.infoPartnerMerchant.Identity = response.Identity;
      this.infoPartnerMerchant.ResponsibleName = response.ResponsibleName;
      this.infoPartnerMerchant.ResponsibleIdentity = response.ResponsibleIdentity;
      this.infoPartnerMerchant.Email = response.Email;
      this.isValidated = true;
      this.$bvModal.hide("mValidateMerchant");
    },
    ValidateMerchant() {
      this.validatedMerchant = true;
      this.$refs.ValidateMerchantForm.validate().then(isValid => {
        if (isValid) {
          this.validatedMerchant = false;
          this.loadingValidateMerchant = true;
          this.$store
            .dispatch("ValidateMerchant", this.infoValidateMerchant)
            .then(response => {
              if (response.HasErrorValidate) {
                this.ConfirmHasErrorValidate(response);
              } else {
                this.SetMerchant(response);
              }
            })
            .catch(error => {
              this.$makeToast(undefined, "danger", "Erro ao validar o cliente", error);
            })
            .finally(() => {
              this.loadingValidateMerchant = false;
            });
        }
      });
    },
    CheckValidityStepTax(nextStep) {
      this.$refs.TaxStep.validate().then(valid => {
        if (valid) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/partnersMerchant/partnersMerchant.js